import React from 'react';
import { Mic, MicOff, Video, VideoOff, PhoneOff } from 'lucide-react';

const VideoControls = ({
  isAudioMuted,
  isVideoMuted,
  onToggleAudio,
  onToggleVideo,
  onEndCall,
  isConnected
}) => {
  const controlButtons = [
    {
      id: 'audio',
      icon: isAudioMuted ? <MicOff className="h-6 w-6" /> : <Mic className="h-6 w-6" />,
      label: isAudioMuted ? 'Unmute Audio' : 'Mute Audio',
      onClick: onToggleAudio,
      className: `p-4 rounded-full transition-all duration-200 ${
        isAudioMuted 
          ? 'bg-red-500 hover:bg-red-600 text-white' 
          : 'bg-white/20 hover:bg-white/30 text-white'
      }`,
      disabled: !isConnected
    },
    {
      id: 'video',
      icon: isVideoMuted ? <VideoOff className="h-6 w-6" /> : <Video className="h-6 w-6" />,
      label: isVideoMuted ? 'Turn On Video' : 'Turn Off Video',
      onClick: onToggleVideo,
      className: `p-4 rounded-full transition-all duration-200 ${
        isVideoMuted 
          ? 'bg-red-500 hover:bg-red-600 text-white' 
          : 'bg-white/20 hover:bg-white/30 text-white'
      }`,
      disabled: !isConnected
    },
    {
      id: 'end',
      icon: <PhoneOff className="h-6 w-6" />,
      label: 'End Call',
      onClick: onEndCall,
      className: 'p-4 rounded-full bg-red-500 hover:bg-red-600 text-white transition-all duration-200',
      disabled: false
    }
  ];

  return (
    <div className="max-w-6xl mx-auto">
      <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6">
        <div className="flex justify-center items-center space-x-6">
          {controlButtons.map((button) => (
            <button
              key={button.id}
              className={button.className}
              onClick={button.onClick}
              disabled={button.disabled}
              title={button.label}
              aria-label={button.label}
            >
              {button.icon}
            </button>
          ))}
        </div>
        
        {/* Connection Status */}
        <div className="text-center mt-4">
          <div className={`inline-flex items-center space-x-2 px-3 py-1 rounded-full text-sm ${
            isConnected 
              ? 'bg-green-500/20 text-green-300' 
              : 'bg-red-500/20 text-red-300'
          }`}>
            <div className={`w-2 h-2 rounded-full ${isConnected ? 'bg-green-300' : 'bg-red-300'}`} />
            <span>{isConnected ? 'Connected' : 'Disconnected'}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoControls;